import ProductAttributeItem from "../ProductAttributeItem";
import React from "react";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { MadeIn } from "@sbi-international/boutik.gatsby.plugin.components";
import { useTranslation } from "react-i18next";
import { IProduct } from "@sbi-international/boutik.gatsby.plugin.services";

type ProductSummaryAttributesProps = {
    product: Queries.ProductsJson;
    productData: IProduct | undefined;
};

export default function ProductSummaryAttributes(props: ProductSummaryAttributesProps) {
    const { product } = props;
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation("templatePages");

    const pWMaSoi = product.attributes?.PWMaSoi;
    const dimExHLiValue = product.attributes?.DimExHLi?.values?.[0]?.[currentLocale];
    const dimExHPiValue = product.attributes?.DimExHPi?.values?.[0]?.[currentLocale];
    const dimExHHiValue = product.attributes?.DimExHHi?.values?.[0]?.[currentLocale];
    const longBuci = product.attributes?.LongBuci;
    const emiss = product.attributes?.Emiss;
    const surfi = product.attributes?.Surfi;

    return (
        <div className="summary-attributes">
            {(props.productData?.isMadeInCanada || props.productData?.isMadeInUSA) && (
                <ProductAttributeItem label={t("made-in-flag")}>
                    {<MadeIn product={props.productData} />}
                </ProductAttributeItem>
            )}

            {pWMaSoi && (
                <ProductAttributeItem label={pWMaSoi.name?.[currentLocale]}>
                    {pWMaSoi.values?.[0]?.[currentLocale]}
                </ProductAttributeItem>
            )}

            {(dimExHLiValue || dimExHPiValue || dimExHHiValue) && (
                <ProductAttributeItem label={`Dimensions`}>
                    <div style={{ backgroundColor: "blues" }}>
                        {dimExHLiValue}
                        {t("specs-W")}
                        {dimExHPiValue}
                        {t("specs-D")}
                        {dimExHHiValue}
                        {t("specs-H")}
                    </div>
                </ProductAttributeItem>
            )}

            {longBuci && (
                <ProductAttributeItem label={longBuci.name?.[currentLocale]}>
                    {longBuci.values?.[0]?.[currentLocale]}
                </ProductAttributeItem>
            )}

            {emiss && (
                <ProductAttributeItem label={emiss.name?.[currentLocale]}>
                    {emiss.values?.[0]?.[currentLocale]}
                </ProductAttributeItem>
            )}

            {surfi && (
                <ProductAttributeItem label={surfi.name?.[currentLocale]}>
                    {surfi.values?.[0]?.[currentLocale]}
                </ProductAttributeItem>
            )}
        </div>
    );
}
